// extracted by mini-css-extract-plugin
export default {"root":"FinancesRoot_root__S2Gzs","emptyWarn":"FinancesRoot_emptyWarn__FbB5G","placeHolderShimmer":"FinancesRoot_placeHolderShimmer__b2HT4"};